module.exports = __webpack_public_path__ + "img/langham-london-logo.39bdc1ab.jpg";